// helpers
import setEnv from "@global/helpers/setEnv";
import excuteByDom from "@global/helpers/excuteByDom";

// globalUI
import { init as gotop } from "@global/components/global/gotop";
import focusInput from "@global/components/global/focusInput";
import accordion from "@global/components/global/accordion";
import hashAccordion from "@global/components/global/hashAccordion";
import floatLabel from "@global/components/global/floatLabel";
import formInputOrder from "@global/components/global/formInputOrder";
import Popup from "@global/components/global/popup";
import Navigation from "./template/navigation";

// promotion
import FooterNotice from "@global/components/promotion/footerNotice";

// expose functions to Global namespace
window.genquo = window.genquo || {};
window.nowEnv = window.nowEnv || {};
window.nowBrand = window.genquo;

genquo.globalConfig = {
	id: "genquo",
	name: "genquo",
	devPort: "89",
	host: "www.genquo.com",
	alertTitle: "提示訊息",
};

genquo.constants = {
	addToCartUrl: "/Shopping/MiniCart/",
	addToCartUrl_Pre: "/Shopping/ReservationMiniCart/",
	todayViewImg: "/Product/DetailByBarcode",
	GetBanners: "/Home/GetBanners", // 取得全域廣告
	todayViewImgType: "POST",
};

genquo.miniCartConfig = {
	maxBuyAmount: 20,
	mobileNotice: true,
	cartCookieName: "genquocart",
	preCartCookieName: "genquoreservationcart",
};

// 每個區塊的預設圖片路徑
genquo.imagePlaceholder = {
	default: "/img/inf_618x788.jpg",
};

function globalCtrl() {
	// environment
	nowEnv.NowIsDev = setEnv.isDev(); // 得知是否為本機開發環境
	nowEnv.NowIsTest = setEnv.isTest(); // 得知是否為測試環境
	nowEnv.NowMyEquipment = setEnv.myEquipment(); // 得知現在的裝置類型
	nowEnv.NowIsLogin = setEnv.isLogin(); // 得知是否登入
	nowEnv.NowMyCookie = setEnv.myCookie(); // 得知目前裝置是否允許Cookie
	nowEnv.NowMyStorage = setEnv.myStorage(); // 得知目前裝置是否允許Storage
	nowEnv.pageDependReact = setEnv.pageDependReact(); // 得知目前頁面是否有調用React lib
	setEnv.windowReload();

	// require component after global variable setted

	// const topBanner = require('./template/topBanner')

	// if (nowEnv.pageDependReact) {
	//   // 跟 miniCart 相關的調用需要依賴 React
	//   const miniCart = require('./pages/cart/miniCart')
	//   miniCart.init()
	//   miniCart.render()
	//   // expose functions to Global namespace
	//   genquo.miniCart = miniCart

	//   const Lightbox = require('components/global/Lightbox')
	//   Lightbox.init()
	// }

	Navigation.navGlobal();
	Navigation.globalSearch(".global-search");

	// globalUI
	focusInput("#global-search");
	accordion(".order-accordion");
	// hashAccordion('.accordion')
	floatLabel();
	// excuteByDom(
	//   gotop.bind(
	//     this,
	//     nowEnv.NowMyEquipment ? '.footer_wrap' : '.header-inner',
	//     {toggle: {target: $(window).height(), timeout: 0, duration: 250}}
	//   ),
	//   [
	//     '#home-content-women', // 首頁
	//     '#new-arrival, #product-list, #search-result, #product-page', // 商品相關頁面
	//     '#article-list, #article-content' // Daily wear 文章單元
	//   ]
	// )

	excuteByDom(
		function () {
			$("body").on("click", ".btn-forgot-pwd", function (e) {
				e.preventDefault();
				$(this).closest("ul").closest("li").toggle(0);
				$(this).closest("ul").closest("li").siblings("li").fadeToggle(0);
				$("#accountForgot").focus();
			});

			$("body").on("click", ".btn-back", function (e) {
				e.preventDefault();
				$(this).closest("li").toggle(0);
				$(this).closest("li").siblings("li").fadeToggle(0);
				$("#username").focus();
			});
		},
		[".dialog__content--signin ,.secnav-right"] // 純登入頁面 (非LightBox出現方式)
	);

	formInputOrder({
		inputArray: [".subnav--newsletter__input"],
		submitButton: ".subnav--newsletter__btn",
	});
	formInputOrder({
		inputArray: [".footer__newsletter__txt"],
		submitButton: "#btnNewletter",
	});
	formInputOrder({
		inputArray: ["#account, #username", "#password", "#captchaTxt, #LoginCode"],
		submitButton: "#btnLogin, #btnShoppingLogin",
	});

	// condition
	if (nowEnv.NowMyEquipment) {
		// 手機版
		// template
		Navigation.navMobile();
		Navigation.subnavMobile();

		excuteByDom(() => {
			const footerNotice = new FooterNotice();
			footerNotice.init();
		}, ["#home-content"]);

		// $('.main').before($('.header__logo'))
	} else {
		// 桌機版
		// template
		// navigation.navDesktop()
		Navigation.subnavDesktop();
		Navigation.navDesktop();
		// 未登入
		// if (!nowEnv.NowIsLogin) {
		//   // 登入
		//   $('.secnav-right__signin > a').dialogPopup({
		//     name: 'signin',
		//     content: 'ul.view',
		//     callback: () => { $('#username').focus() }
		//   })
		// }

		// promotion
		// topBanner(() => {
		//   navigation.toggleHeaderClass()
		//   $('#topBanner').show()
		// })
	}

	// expose functions to Global namespace
	// genquo.dialogPopup = {
	//   close: () => { $(window).trigger('closeDialogPopup') }
	// }
	genquo.alertType = "single";
	genquo.alert = Popup("alert");
	genquo.confirm = Popup("confirm");
	genquo.notice = Popup("notice");
}

export default globalCtrl;
